import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listDataTable: {},
  listColumn:{},
  edits:{}
};
const ledgerSlice = createSlice({
  name: "ledger",
  initialState,
  reducers: {
    setListDataTable: (state,{payload}) => {
      state.listDataTable[payload.key] = payload.data;
    },
    setListColumn: (state,{payload}) => {
      state.listColumn[payload.key] = payload.data;
    },
    updateCell: (state, action) => {
      const { id, colKey, value } = action.payload;
      if (!state.edits[id]) {
        state.edits[id] = { [colKey]: value };
      }
      state.edits[id][colKey] = value;
    },
    resetEdits: (state) => {
      state.edits = {};
    },
  }
});

export const { setListDataTable, setListColumn ,updateCell,resetEdits} = ledgerSlice.actions;

export default ledgerSlice.reducer;
